<form [formGroup]="eventForm"
      class="event-form">

  <div class="row">
    <mat-form-field class="event-title">
      <mat-label>Event title</mat-label>
      <input matInput
             type="text"
             formControlName="name"
             autocomplete="off">
      <app-input-error [formControlItem]="eventForm.controls['name']"></app-input-error>
    </mat-form-field>
    <mat-form-field class="entity-dropdown">
      <mat-label>Entity Type</mat-label>
      <mat-select formControlName="entityTypeId"
                  class="capitalize">
        <mat-option *ngFor="let option of entityTypeOptions"
                    [value]="option.id"
                    class="capitalize">{{option.namePlural}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <h5 class="caps caps--light txt-12 row">
    Date &amp; time

    <div class="timezone-input">
      <mat-select formControlName="timeZone">
        <mat-select-trigger class="link">
          {{eventForm.controls['timeZone'].value | timezone}}
        </mat-select-trigger>
        <mat-option *ngFor="let option of timezoneOptions"
                    [value]="option.name"
                    class="capitalize">{{option.name | timezone}}</mat-option>
      </mat-select>
    </div>
  </h5>

  <div class="row">
    <div class="row">

      <mat-form-field class="date-input">
        <mat-label>Start date</mat-label>
        <input matInput
               [matDatepicker]="startDate"
               formControlName="startDate"
               autocomplete="off">
        <mat-datepicker-toggle matSuffix
                               [for]="startDate"></mat-datepicker-toggle>
        <mat-datepicker #startDate>
        </mat-datepicker>
        <app-input-error [formControlItem]="eventForm.controls['startDate']"></app-input-error>
      </mat-form-field>

      <app-time-input class="time-input"
                      label="Start time"
                      placeholder="Start time"
                      [formControl]="eventForm.get('startTime')"></app-time-input>

      <div class="link align-right"
           *ngIf="!showEndDateTime && !eventForm.controls['endDate'].value && addEndDateEnabled()"
           (click)="addEndDate()">
        Add end date/time
      </div>

      <!-- <mat-slide-toggle class="col__ col__sm--30">All day</mat-slide-toggle> -->
    </div>

    <div *ngIf="showEndDateTime || eventForm.controls['endDate'].value"
         class="row">
      <mat-form-field class="date-input">
        <mat-label>End date</mat-label>
        <input matInput
               [matDatepicker]="endDate"
               formControlName="endDate"
               [min]="eventForm.controls['startDate'].value">
        <mat-datepicker-toggle matSuffix
                               [for]="endDate"></mat-datepicker-toggle>
        <mat-datepicker #endDate>
        </mat-datepicker>
        <app-input-error [formControlItem]="eventForm.controls['endDate']"></app-input-error>
      </mat-form-field>

      <app-time-input class="time-input"
                      label="End time"
                      placeholder="End time"
                      [onlyAfter]="minEndTime"
                      [formControl]="eventForm.get('endTime')"></app-time-input>

      <div class="link link--red align-right"
           (click)="clearEndDate()">Clear end date/time
      </div>
    </div>
  </div>

  <h5 class="caps caps--light txt-12">Location</h5>

  <div class="row mb-0075"
       [ngClass]="{'mb-0150': !location.value}">

    <mat-button-toggle-group #location="matButtonToggleGroup"
                             formControlName="locationType">
      <mat-button-toggle value="InPerson">In person</mat-button-toggle>
      <mat-button-toggle value="Virtual">Virtual</mat-button-toggle>
    </mat-button-toggle-group>

  </div>

  <mat-form-field class="col__"
                  *ngIf="location.value === 'Virtual'">
    <mat-label>Link/instructions to join virtually</mat-label>
    <input matInput
           type="text"
           autocomplete="off"
           formControlName="locationNote">
  </mat-form-field>

  <app-address-form *ngIf="location.value === 'InPerson'"
                    formControlName="address"
                    [hideConfirmedCheckbox]="true">
  </app-address-form>

  <h5 class="caps caps--light txt-12 mt-0075 nomb">Description</h5>
  <app-wysiwyg-input formControlName="description"></app-wysiwyg-input>

  <div class="mt-0100">
    <app-user-list-autocomplete label="Event Hosts"
                                [userIds]="assignedUsers"
                                [postFilterFn]="postFilterUsersAutocompleteFn"
                                [requiredUserIds]="requiredUserIds"
                                [campaignId]="campaignId"
                                [disabled]="!canChangeAssignedUsers"
                                (userIdsChange)="this.assignedUsers = $event"></app-user-list-autocomplete>
  </div>

</form>
